"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const object_path_1 = __importDefault(require("object-path"));
const helpers_1 = require("../../lib/helpers");
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const useInputForm_1 = require("../../hooks/useInputForm");
const InputButtonManager_1 = require("./InputButtonManager");
const Search_1 = __importDefault(require("../Search/Search"));
const SearchBox_1 = __importDefault(require("../Search/SearchBox"));
const SearchResultsPopover_1 = __importDefault(require("../Search/SearchResultsPopover"));
const SearchResults_1 = __importDefault(require("../Search/SearchResults"));
const Button_1 = __importDefault(require("../Util/Button"));
const FormContext_1 = require("../../contexts/FormContext");
const Badge_1 = __importDefault(require("../Util/Badge"));
const Icon_1 = __importDefault(require("../Util/Icon"));
const Journey_1 = require("../../lib/Journey");
const MultiSearchValueBadges = ({ value, name, beforeFormChange }) => {
    const { formData, setFormData } = react_1.useContext(FormContext_1.FormContext);
    const onRemoveValueClick = (e, row) => __awaiter(void 0, void 0, void 0, function* () {
        let newFormData = Object.assign({}, formData);
        const currentValue = object_path_1.default.get(newFormData, name);
        const newValue = currentValue.filter((r) => r !== row);
        object_path_1.default.set(newFormData, name, newValue);
        if (beforeFormChange) {
            newFormData = yield beforeFormChange(e, newFormData);
        }
        setFormData(newFormData);
    });
    return (react_1.default.createElement("div", { className: "j-multi-search-value-panel" }, (value !== null && value !== void 0 ? value : []).map((row) => (react_1.default.createElement(Badge_1.default, { key: row, className: "j-multi-search-value" },
        react_1.default.createElement("span", null, row),
        react_1.default.createElement(Button_1.default, { className: "size-sm", onClick: (e) => onRemoveValueClick(e, row) },
            react_1.default.createElement(Icon_1.default, { src: Journey_1.Journey.icons().CLOSE })))))));
};
const SearchInput = (props) => {
    var _a, _b, _c;
    const { children, paginateProps, multiValues, loadOnFocus, name } = props;
    const { formData, setFormData } = react_1.useContext(FormContext_1.FormContext);
    const inputFormProps = useInputForm_1.useInputForm(props);
    const getResultKey = (_a = props.getResultKey) !== null && _a !== void 0 ? _a : ((hit) => hit.name);
    const getResultLabel = (_b = props.getResultLabel) !== null && _b !== void 0 ? _b : ((hit) => hit.name);
    const getResultValue = (_c = props.getResultValue) !== null && _c !== void 0 ? _c : ((hit) => hit.name);
    const onResultClickHandle = (e, result) => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e;
        let newValue = getResultValue(result);
        if (name) {
            let newFormData = Object.assign({}, formData);
            if (multiValues) {
                const arrayOfValues = (_d = object_path_1.default.get(newFormData, name)) !== null && _d !== void 0 ? _d : [];
                arrayOfValues.push(newValue);
                newValue = arrayOfValues;
            }
            object_path_1.default.set(newFormData, name, newValue);
            if (props.beforeFormChange) {
                e.searchResult = result;
                newFormData = yield props.beforeFormChange(e, newFormData);
            }
            setFormData(newFormData);
        }
        (_e = props.onResultClick) === null || _e === void 0 ? void 0 : _e.call(props, result);
    });
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: props.className, label: props.label, name: props.name, error: props.error },
        react_1.default.createElement(InputLabel_1.default, { className: "retracted" }),
        react_1.default.createElement(Search_1.default, { loadOnFocus: loadOnFocus, paginateProps: paginateProps },
            react_1.default.createElement(SearchBox_1.default, Object.assign({}, helpers_1.without(props, ['className']), { 
                /* If we have multi values, the box doesn't show the value, we'll use the <MultiSearchValueBadges/> below to show. */
                value: multiValues ? undefined : inputFormProps.value, 
                /* Dont have a name so <TextInput/> doesnt try to update the form */
                name: multiValues ? undefined : props.name, label: "" })),
            multiValues
                ? (react_1.default.createElement(MultiSearchValueBadges, { name: props.name, beforeFormChange: props.beforeFormChange, value: inputFormProps.value })) : null,
            react_1.default.createElement(SearchResultsPopover_1.default, null,
                react_1.default.createElement(SearchResults_1.default, null, (hits) => hits.map((hit) => (react_1.default.createElement(Button_1.default, { key: getResultKey(hit), className: "j-search-input-result", onClick: (e) => onResultClickHandle(e, hit) },
                    react_1.default.createElement("span", null, getResultLabel(hit)))))))),
        children,
        react_1.default.createElement(InputButtonManager_1.InputButtonManager, Object.assign({}, props)),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-search-input', SearchInput);
